import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { keyframes } from "../Emotion";
export var AnimationKeyframes = {
  spinnerCircleOffset: function spinnerCircleOffset() {
    return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        0% { stroke-dashoffset: 231.25%; }\n        100% { stroke-dashoffset: 0%; }\n      "])));
  },
  spinnerCircleLength: function spinnerCircleLength() {
    return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        0% { stroke-dasharray: 62.5%, 168.75%; }\n        50% {  stroke-dasharray: 187.5%, 43.75%; }\n        100% { stroke-dasharray: 62.5%, 168.75%; }\n      "])));
  },
  spinnerCircleRotate: function spinnerCircleRotate() {
    return keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        100% { transform: rotate(360deg); }\n      "])));
  },
  spinnerColor: function spinnerColor(t) {
    return keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n        100%, 0% { stroke: ", "; }\n        40% { stroke: ", "; }\n        66% { stroke: ", "; }\n        80%, 90% { stroke: ", "; }\n      "])), t.red, t.yellow, t.green, t.brand);
  }
};